import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { MarketplaceResource } from "@exonn/js-sdk";

export const module: ModuleOptions<MarketplaceResource> = {
  resource: ResourceEnum.Marketplace,
  bigIcon: <span className={"icon-20-marketplaces"} />,
  smallIcon: <span className={"icon-15-marketplaces"} />,
};
